<template>
  <div>
    <UpdateAvailableBanner />
    <!--
      Aktiv prosjekt-slug brukes som key på topp-nivå router-view slik at
      hele tre under IcsMain teardowns (onUnmounted) og bygges på nytt
      (onMounted) ved prosjekt-bytte. Dette er HOVEDmekanismen som hindrer
      at data fra forrige prosjekt henger igjen — ikke en watch eller en
      Pinia-reset alene.
    -->
    <router-view :key="rootRouteKey" />
    <!--
      AppToastHost mountes globalt (utenfor shells) så ephemeral toaster
      forblir synlige på alle routes — inkludert uautentisert login og
      overgangs-routes. NotificationsComponent (det persistente side-panelet)
      mountes derimot inni hver shell's main-område per WI #1338.
    -->
    <AppToastHost />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppToastHost from "@/components/appShell/AppToastHost.vue";
import UpdateAvailableBanner from "@/components/UpdateAvailableBanner.vue";

const route = useRoute();

const rootRouteKey = computed(() => {
  const slug = route.params?.projectSlug;
  if (typeof slug === 'string' && slug.length > 0) return `project:${slug}`;
  if (Array.isArray(slug) && slug.length > 0) return `project:${slug.join(':')}`;
  return 'no-project';
});
</script>
